import { RootStore } from "@intrasync/stores";
import rootStoreConfig from "./rootStoreConfig";
import apiClient from "./api-client/apiClient";

interface Window {
  rootStore?: RootStore;
  dateFNS?: unknown;
  __STORE_COUNT__?: number;
  __MEMORY_MONITOR__?: unknown;
}

export function createRootStore(): RootStore {
  // The @intrasync/stores RootStore no longer builds the Feathers app internally —
  // it must be provided via props.app. Build it the same way the legacy RootStore
  // did, via the existing apiClient (socket.io transport + auth, with token refresh),
  // deriving the mode-based auth/refresh storage keys identically.
  const mode = (rootStoreConfig.mode ?? "development") as Parameters<typeof apiClient>[0];
  const isProd = ["production", "prod", "live"].includes(mode);
  const authStorageKey = `feathers-jwt${isProd ? "" : `-${mode}`}`;
  const refreshStorageKey = `refresh-token${isProd ? "" : `-${mode}`}`;

  const app = apiClient(mode, {
    authStorageKey,
    refreshStorageKey,
    enableFindOne: true,
    ...(rootStoreConfig.apiOptions as object),
  });

  const rootStore = new RootStore({ ...rootStoreConfig, app });

  // if (import.meta.env.MODE === "development") {
  (window as Window).rootStore = rootStore;
  // }

  return rootStore;
}
